function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import AssetComponent from "components/core/asset/asset-component";
import MobileTabs from "segments/desktop/core-components/mobile-tabs/mobile-tabs";
import Title from "segments/desktop/core-components/title/title";
import { XS_M } from "constants/sizes";
import classnames from "classnames";
import { StyledSideBySideBoardViewsComponentTabsMobileComponent } from "./side-by-side-board-views-component-tabs-mobile-component.scss";
const SideBySideBoardViewsComponentTabsMobileComponent = (props)=>{
    const [selectedTab, setSelectedTab] = useState(0);
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const { tabs } = props;
    const navigationItemRenderer = (tab, index)=>{
        const { tabLabel, tabId, image } = tab;
        return /*#__PURE__*/ _jsx("div", {
            className: classnames("tab-nav-board-views-button", {
                selected: selectedTab === index
            }),
            children: /*#__PURE__*/ _jsx(Title, {
                title: tabLabel,
                titleIcon: image === null || image === void 0 ? void 0 : image.src,
                titleSize: XS_M
            })
        });
    };
    const carouselItemRenderer = (tab)=>{
        const { asset } = tab;
        return /*#__PURE__*/ _jsx("div", {
            className: "asset-and-paragraphs-wrapper",
            children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset))
        });
    };
    return /*#__PURE__*/ _jsx(StyledSideBySideBoardViewsComponentTabsMobileComponent, {
        className: "use-cases-tabs-mobile-component",
        children: /*#__PURE__*/ _jsx(MobileTabs, {
            tabs: tabs,
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        })
    });
};
export default SideBySideBoardViewsComponentTabsMobileComponent;
